(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("osjsClient", [], factory);
	else if(typeof exports === 'object')
		exports["osjsClient"] = factory();
	else
		root["osjsClient"] = factory();
})(window, function() {
return 